import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { applyPolyfills, defineCustomElements } from '@vime/core/loader';
import { Chart, registerables } from 'chart.js';

import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';

if (environment.production) {
  enableProdMode();
}

Chart.register(...registerables);

applyPolyfills().then(() => {
  defineCustomElements(window);
});

platformBrowserDynamic().bootstrapModule(AppModule);
